// App Store
import { app } from './utils/store'

// Classes::Managers
import { AccordionManager } from './classes/Accordions'

var $ = jQuery

class App {
    constructor() {
        app.init = true
        app.root = document.body
        this.init()
    }

    // Inizializzazione
    init = () => {
        
        // Inizializza subito printPage
        
        $(document).ready(() => {
            // Nascondi tutti i social tranne Facebook all'avvio
            $('[data-network]').addClass('d-none')
            $('[data-network="facebook"]').removeClass('d-none')
            
            // Attiva il pulsante di Facebook
            $('.btn-switch').removeClass('active')
            $('.btn-switch.fb').addClass('active')

            // Inizializza le altre funzionalità
            this.initCarousels()
            this.initSocialSwitcher()
            this.initHashtagMentions()
            this.initDateControls()
            $(window).trigger('resize')
            this.initPrintPage()
        })
        
    }

    initPrintPage = () => {

        document.querySelector('.btn-print').addEventListener('click', function() {
            const plan = document.getElementById('plan-container');
            plan.classList.add('print-active');

            let overlay = document.createElement('div');
            overlay.classList.add('overlay');
            overlay.innerHTML = `
                <div class="overlay-content" style="text-align: center; width: 100vw; height: 100vh; background-color: rgba(255, 255, 255, 1); position: fixed; top: 0; left: 0; z-index: 9999; display: flex; justify-content: center; align-items: center;">
                    <h1 style="font-size: 44px; color: #000;">Sto generando il PDF...</h1>
                </div>
            `;
            document.body.style.overflow = 'hidden';
            document.body.appendChild(overlay);


            
            // Clicca su tutti i bottoni switch
            document.querySelectorAll('.btn-switch').forEach(btn => btn.click());
            
            // Mostra tutti i network
            plan.querySelectorAll('.plan-network').forEach(el => {
                el.classList.remove('d-none');
            });
            
            // Aggiungi classe per il controllo della stampa a ogni li
            const printItems = plan.querySelectorAll('.single-post');
            printItems.forEach(post => {
                post.classList.add('print-item');
            });

            // Verifica se le librerie sono già caricate
            if (typeof html2canvas === 'undefined' || typeof jspdf === 'undefined') {
                loadScripts(() => {
                    generatePDF(plan, printItems);
                });
            } else {
                generatePDF(plan, printItems);
            }
        });

        function generatePDF(plan, printItems) {
            let currentItem = 0;
            const { jsPDF } = window.jspdf;
            let pdf;

            // Definiamo dimensioni fisse per la pagina PDF
            const PAGE_WIDTH = 297; // A4 larghezza in mm
            const PAGE_HEIGHT = 210; // A4 altezza in mm
            const MAX_IMAGE_WIDTH = 270; // Larghezza massima immagine in mm
            const MAX_IMAGE_HEIGHT = 195; // Altezza massima immagine in mm (lasciamo un po' di margine)

            function initializePDF() {
                return new jsPDF({
                    orientation: 'landscape',
                    unit: 'mm',
                    format: 'a4'
                });
            }

            function processNextItem() {
                const currentElement = printItems[currentItem];
                const parentNetwork = currentElement.closest('.plan-network');
                const isFirstOfNetwork = currentElement === parentNetwork.querySelector('.single-post');
                
                html2canvas(currentElement, {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    windowWidth: currentElement.scrollWidth,
                    windowHeight: currentElement.scrollHeight
                }).then(canvas => {
                    // Inizializziamo il PDF solo la prima volta o aggiungiamo una nuova pagina
                    if (currentItem === 0) {
                        pdf = initializePDF();
                    } else {
                        pdf.addPage();
                    }

                    // Calcoliamo le dimensioni mantenendo l'aspect ratio
                    const imgWidth = canvas.width;
                    const imgHeight = canvas.height;
                    const aspectRatio = imgWidth / imgHeight;

                    let finalWidth, finalHeight;

                    if (aspectRatio > MAX_IMAGE_WIDTH / MAX_IMAGE_HEIGHT) {
                        // L'immagine è più larga che alta
                        finalWidth = MAX_IMAGE_WIDTH;
                        finalHeight = MAX_IMAGE_WIDTH / aspectRatio;
                    } else {
                        // L'immagine è più alta che larga
                        finalHeight = MAX_IMAGE_HEIGHT;
                        finalWidth = MAX_IMAGE_HEIGHT * aspectRatio;
                    }

                    // Calcoliamo la posizione per centrare l'immagine nella pagina
                    const x = (PAGE_WIDTH - finalWidth) / 2;
                    const y = (PAGE_HEIGHT - finalHeight) / 2;

                    // Se è il primo elemento di un network, aggiungiamo il customer e il titolo
                    if (isFirstOfNetwork) {
                        const customerElement = document.querySelector('.customer');
                        if (customerElement) {
                            html2canvas(customerElement, {
                                scale: 2,
                                useCORS: true,
                                logging: false
                            }).then(customerCanvas => {
                                // Impostiamo dimensioni massime per il logo customer
                                const maxCustomerWidth = 150; // mm
                                const customerAspectRatio = customerCanvas.width / customerCanvas.height;
                                const customerWidth = maxCustomerWidth;
                                const customerHeight = maxCustomerWidth / customerAspectRatio;
                                
                                // Centriamo il logo customer nella parte superiore
                                const customerX = (PAGE_WIDTH - customerWidth) / 2;
                                const customerY = 20;
                                
                                const customerImgData = customerCanvas.toDataURL('image/jpeg', 1.0);
                                pdf.addImage(customerImgData, 'JPEG', customerX, customerY, customerWidth, customerHeight, '', 'FAST');
                                
                                // Aggiungiamo il titolo del network sotto il logo
                                const networkName = parentNetwork.getAttribute('data-network').toUpperCase();
                                pdf.setFontSize(24);
                                pdf.setFont(undefined, 'bold');
                                
                                const textWidth = pdf.getTextWidth(networkName);
                                const textX = (PAGE_WIDTH - textWidth) / 2;
                                const textY = customerY + customerHeight + 15;
                                
                                pdf.text(networkName, textX, textY);
                                
                                // Nuova pagina per il contenuto
                                pdf.addPage();
                                
                                // Aggiungiamo l'immagine del post centrata
                                const imgData = canvas.toDataURL('image/jpeg', 1.0);
                                pdf.addImage(imgData, 'JPEG', x, y, finalWidth, finalHeight, '', 'FAST');
                                
                                continueProcess();
                            });
                            return;
                        }
                    }

                    // Se non è il primo elemento o non c'è customer, aggiungiamo solo l'immagine
                    const imgData = canvas.toDataURL('image/jpeg', 1.0);
                    pdf.addImage(imgData, 'JPEG', x, y, finalWidth, finalHeight, '', 'FAST');
                    
                    continueProcess();
                }).catch(error => {
                    console.error('Errore durante la generazione del PDF:', error);
                    plan.classList.remove('print-active');
                });
            }

            function continueProcess() {
                currentItem++;
                if (currentItem < printItems.length) {
                    processNextItem();
                } else {
                    // Abbiamo finito, salviamo il PDF
                    pdf.save('piano-editoriale.pdf');
                    
                    // Ripristina lo stato originale
                    plan.classList.remove('print-active');
                    printItems.forEach(post => {
                        post.classList.remove('print-item');
                    });
                    plan.querySelectorAll('.plan-network').forEach((el, index) => {
                        if(index > 0) {
                            el.classList.add('d-none');
                        }
                    });

                    document.querySelector('.overlay').remove();
                    document.body.style.overflow = 'auto';
                }
            }

            // Inizia il processo
            processNextItem();
        }
    }

    // Inizializzazione carousel per ogni social
    initCarousels = () => {
        // Facebook Carousel
        $('.fb-carousel').each(function() {
            const nav = $(this).parent().find('.carousel-nav')
            $(this).slick({
                arrows: false,
                dots: true,
                // appendDots: dotsNav,
                infinite: false
            })
        })

        // Instagram Carousel
        $('.ig-carousel').each(function() {
            const dotsNav = $(this).closest('.post').find('.social-actions .user-actions .dots-nav')
            $(this).slick({
                arrows: false,
                dots: true,
                // appendDots: dotsNav,
                infinite: false
            })
        })

        // LinkedIn Carousel
        $('.in-carousel').each(function() {
            const nav = $(this).parent().find('.carousel-nav')
            $(this).slick({
                slidesToShow: 1,
                centerMode: false,
                variableWidth: true,
                prevArrow: nav.find('.prev'),
                nextArrow: nav.find('.next')
            })
        })
    }

    // Gestione switch tra social network
    initSocialSwitcher = () => {
        // Gestione click generale
        $('.switcher .btn-switch').on('click', function(e) {
            e.preventDefault()
            $('.btn-switch').removeClass('active')
            $(this).addClass('active')
            $('.fb-carousel').trigger('refresh.owl.carousel')
            $('html, body').animate({ scrollTop: 0 }, 500)
        })

        // Switch handlers per ogni social
        const socialHandlers = {
            'fb': () => {
                $('[data-network]').addClass('d-none')
                $('[data-network="facebook"]').removeClass('d-none')
                $('.fb-carousel').slick('refresh')
            },
            'ig': () => {
                $('[data-network]').addClass('d-none')
                $('[data-network="instagram"]').removeClass('d-none')
                $('.ig-carousel').slick('refresh')
            },
            'ig-stories': () => {
                $('[data-network]').addClass('d-none')
                $('[data-network="instagram_stories"]').removeClass('d-none')
            },
            'in': () => {
                $('[data-network]').addClass('d-none')
                $('[data-network="linkedin"]').removeClass('d-none')
                $('.in-carousel').slick('refresh')
            },
            'tiktok': () => {
                $('[data-network]').addClass('d-none')
                $('[data-network="tiktok"]').removeClass('d-none')
            },
            'x': () => {
                $('[data-network]').addClass('d-none')
                $('[data-network="x"]').removeClass('d-none')
            }
        }

        // Binding degli handlers
        Object.entries(socialHandlers).forEach(([social, handler]) => {
            $(`.btn-switch.${social}`).on('click', (e) => {
                e.preventDefault()
                handler()
            })
        })
    }

    // Gestione hashtag e menzioni
    initHashtagMentions = () => {
        const socialSelectors = {
            'fb': '.fb-post .col.content',
            'ig': '.ig-post .post-content',
            'in': '.in-post .post-content',
            'x': '.x-post .post-content',
        }

        const replacePattern = (text, type, socialPrefix) => {
            const patterns = {
                hashtag: /(^|\W)#(\w+)/g,
                mention: /(^|\W)@(\w+)/g
            }
            
            return text.replace(patterns[type], (_, $1, $2) => 
                `${$1} <span class='${socialPrefix}-${type === 'hashtag' ? 'hash' : 'at'}'>${type === 'hashtag' ? '#' : '@'}${$2}</span>`
            )
        }

        Object.entries(socialSelectors).forEach(([social, selector]) => {
            $(selector).each(function() {
                let content = $(this).html()
                content = replacePattern(content, 'hashtag', social)
                content = replacePattern(content, 'mention', social)
                $(this).html(content)
            })
        })
    }

    // Gestione controlli data
    initDateControls = () => {
        const dateControl = $('#controls #date')
        if (!dateControl.length) return

        const currentUrl = new URL(window.location.href)
        const period = currentUrl.searchParams.get('period')
        const planItems = $('#controls #related-plans li')

        // Imposta il valore iniziale
        const selectedValue = period || 'default'
        $(`#controls #date option[value="${selectedValue}"]`).attr('selected', 'selected')

        // Aggiorna la visualizzazione dei piani
        const updatePlans = (value) => {
            planItems.addClass('d-none')
            $(`#controls #related-plans [data-time="${value}"]`).removeClass('d-none')
            
            if (value !== 'default') {
                $('#related-plans .related').removeClass('d-none')
            }
        }

        // Inizializza la vista
        updatePlans(selectedValue)

        // Handler cambio select
        dateControl.on('change', function(e) {
            const value = e.target.value
            $('#controls #date option').removeAttr('selected')
            $(`#controls #date option[value="${value}"]`).attr('selected', 'selected')
            updatePlans(value)
        })
    }
}

new App()